import FormInput from './FormInput.vue';
import FormFileInput from './FormFileInput.vue';
import FormTextArea from './FormTextArea.vue';
import FormSelect from './FormSelect.vue';
import FormDateInput from './FormDateInput.vue';
import FormCheckbox from './FormCheckbox.vue';
import FormCheckboxToggle from './FormCheckboxToggle.vue';
import FormSwitchBoxList from './FormSwitchBoxList.vue';
import PasswordStrength from './PasswordStrength.vue';

export default { FormInput, FormFileInput, FormTextArea, FormSelect, FormDateInput, FormCheckbox, FormCheckboxToggle, PasswordStrength, FormSwitchBoxList };
